(function () {
  function formatCellValue(value) {
    if (value == null || value === '' || value === '-') {
      return '-';
    }
    return String(value).replace(/\|\|/g, '<br>');
  }

  function getMoneyFormat() {
    var cfg = window.T4Sconfigs || {};
    return cfg.moneyFormat || '${{amount}}';
  }

  function getConvertedCents(cents) {
    var rate = 1;
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
      rate = parseFloat(Shopify.currency.rate);
    }
    if (isNaN(rate) || rate <= 0) {
      rate = 1;
    }
    return Math.round(cents * rate);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = parseInt(cents, 10);
    if (isNaN(cents)) {
      return '';
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';
    var match = format.match(placeholderRegex);
    if (!match) {
      return String(cents / 100);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function triggerCurrencyUpdate() {
    if (typeof jQuery_T4NT !== 'undefined') {
      jQuery_T4NT(document).trigger('currency:update');
    }
  }

  function renderSlotPrice(slot, section, product) {
    var priceEl = slot.querySelector('[data-fb-compare-slot-price]');
    if (!priceEl) {
      return;
    }

    if (!product || !product.price) {
      priceEl.innerHTML = '';
      priceEl.classList.add('is-hidden');
      return;
    }

    var moneyFormat = getMoneyFormat();
    var html = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      html += '<s class="fb-compare__slot-price-compare money" data-basecut4s="' + product.compare_at_price + '">' +
        formatMoney(getConvertedCents(product.compare_at_price), moneyFormat) + '</s>';
    }
    html += '<span class="fb-compare__slot-price-sale money" data-basecut4s="' + product.price + '">' +
      formatMoney(getConvertedCents(product.price), moneyFormat) + '</span>';
    priceEl.innerHTML = html;
    priceEl.classList.remove('is-hidden');
    triggerCurrencyUpdate();
  }

  function hydrateRowValues(section) {
    section.querySelectorAll('[data-fb-compare-row-value]').forEach(function (cell) {
      var text = cell.textContent;
      if (text.indexOf('||') !== -1) {
        cell.innerHTML = formatCellValue(text);
      }
    });
  }

  function getCatalogData(section) {
    if (section._fbCatalogData) {
      return section._fbCatalogData;
    }

    var script = section.querySelector('[data-fb-compare-catalog]');
    if (!script) {
      section._fbCatalogData = [];
      return section._fbCatalogData;
    }

    try {
      section._fbCatalogData = JSON.parse(script.textContent);
    } catch (error) {
      section._fbCatalogData = [];
    }

    return section._fbCatalogData;
  }

  function findCatalogProduct(section, productId) {
    return getCatalogData(section).find(function (product) {
      return String(product.id) === String(productId);
    });
  }

  function getSlots(section) {
    return Array.from(section.querySelectorAll('[data-fb-compare-slot]'));
  }

  function getRows(section) {
    return Array.from(section.querySelectorAll('[data-fb-compare-row]'));
  }

  function getDialog(section) {
    return section.querySelector('[data-fb-compare-dialog]');
  }

  function isSlotVisible(slot) {
    return slot.getAttribute('data-mobile-hidden') !== 'true';
  }

  function getActiveProductIds(section) {
    var addLabel = section.dataset.addProductLabel || 'Ajouter un produit';

    return getSlots(section)
      .filter(function (slot) {
        if (!isSlotVisible(slot)) return false;
        return !slot.classList.contains('is-empty') && slot.dataset.productTitle !== addLabel;
      })
      .map(function (slot) {
        return slot.dataset.productId || '';
      })
      .filter(Boolean);
  }

  function updateSelectedState(section) {
    var activeIds = getActiveProductIds(section);

    section.querySelectorAll('[data-fb-compare-catalog-item]').forEach(function (item) {
      var isSelected = activeIds.indexOf(String(item.dataset.productId)) !== -1;
      item.classList.toggle('is-selected', isSelected);
    });
  }

  function setSlotEmpty(slot, section) {
    var index = Number(slot.dataset.slotIndex);
    var nullMedia = section.querySelector('[data-fb-compare-slots]').dataset.nullMedia;

    slot.dataset.productId = '';
    slot.dataset.productTitle = '';
    slot.classList.add('is-empty');

    var image = slot.querySelector('[data-fb-compare-slot-image]');
    if (image) {
      image.src = nullMedia || '';
      image.alt = '';
    }

    var name = slot.querySelector('[data-fb-compare-slot-name]');
    if (name) {
      name.textContent = section.dataset.addProductLabel || 'Ajouter un produit';
    }

    var link = slot.querySelector('[data-fb-compare-slot-link]');
    if (link) {
      link.href = '#';
    }

    renderSlotPrice(slot, section, null);

    getRows(section).forEach(function (row) {
      var cell = row.querySelector('[data-fb-compare-row-value][data-slot-index="' + index + '"]');
      if (cell) {
        cell.innerHTML = '-';
      }
    });
  }

  function fillSlotFromCatalog(item, section) {
    var dialog = getDialog(section);
    var slotIndex = dialog && dialog.dataset.activeSlot;
    var slot = slotIndex
      ? section.querySelector('[data-fb-compare-slot][data-slot-index="' + slotIndex + '"]')
      : null;
    var product = findCatalogProduct(section, item.dataset.productId);

    if (!slot || !product) {
      return;
    }

    var parsedDetail = product.detail && typeof product.detail === 'object' ? product.detail : {};
    var title = product.title || '';
    var media = product.media || '';
    var url = product.url || '#';

    slot.dataset.productId = String(product.id);
    slot.dataset.productTitle = title;
    slot.classList.remove('is-empty');

    var image = slot.querySelector('[data-fb-compare-slot-image]');
    if (image) {
      image.src = media;
      image.alt = title;
    }

    var name = slot.querySelector('[data-fb-compare-slot-name]');
    if (name) {
      name.textContent = title;
    }

    var link = slot.querySelector('[data-fb-compare-slot-link]');
    if (link) {
      link.href = url;
    }

    renderSlotPrice(slot, section, product);

    getRows(section).forEach(function (row) {
      var key = row.dataset.compareLine;
      var cell = row.querySelector('[data-fb-compare-row-value][data-slot-index="' + slotIndex + '"]');
      if (!cell) {
        return;
      }

      var value = parsedDetail[key];
      if (value != null && value !== '') {
        cell.innerHTML = formatCellValue(value);
      } else {
        cell.innerHTML = '-';
      }
    });

    closeDialog(section);
    updateSelectedState(section);
  }

  function lockPageScroll() {
    if (!window._fbCompareScrollLock) {
      window._fbCompareScrollLock = 0;
    }

    window._fbCompareScrollLock += 1;

    if (window._fbCompareScrollLock === 1) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
  }

  function unlockPageScroll() {
    if (!window._fbCompareScrollLock) {
      return;
    }

    window._fbCompareScrollLock = Math.max(0, window._fbCompareScrollLock - 1);

    if (window._fbCompareScrollLock === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  function openDialog(section, slotIndex) {
    var dialog = getDialog(section);
    if (!dialog) {
      return;
    }

    dialog.dataset.activeSlot = String(slotIndex);
    dialog.classList.add('is-open');
    dialog.setAttribute('aria-hidden', 'false');
    lockPageScroll();
    updateSelectedState(section);
    triggerCurrencyUpdate();
  }

  function closeDialog(section) {
    var dialog = getDialog(section);
    if (!dialog) {
      return;
    }

    if (dialog.classList.contains('is-open')) {
      unlockPageScroll();
    }

    dialog.classList.remove('is-open');
    dialog.removeAttribute('data-active-slot');
    dialog.setAttribute('aria-hidden', 'true');
  }

  function measureHeaderBleed(section) {
    var inner = section.querySelector('.fb-compare__inner');
    if (!inner) {
      return;
    }

    var rect = inner.getBoundingClientRect();
    section.style.setProperty('--fb-compare-bleed-left', Math.max(0, rect.left) + 'px');
    section.style.setProperty('--fb-compare-bleed-right', Math.max(0, window.innerWidth - rect.right) + 'px');
  }

  function initStickyHeader(section) {
    var header = section.querySelector('[data-fb-compare-header]');
    var sentinel = section.querySelector('[data-fb-compare-header-sentinel]');
    if (!header || !sentinel) {
      return;
    }

    measureHeaderBleed(section);

    if (section._fbCompareStickyObserver) {
      section._fbCompareStickyObserver.disconnect();
    }

    section._fbCompareStickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        header.classList.toggle('is-stuck', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    section._fbCompareStickyObserver.observe(sentinel);

    if (!section.dataset.fbCompareStickyResizeBound) {
      section.dataset.fbCompareStickyResizeBound = 'true';
      window.addEventListener('resize', function () {
        document.querySelectorAll('[data-fb-compare]').forEach(measureHeaderBleed);
      });
    }
  }

  function applyMobileRules(section) {
    var mobileBreakpoint = Number(section.dataset.mobileBreakpoint || 800);
    var slots = getSlots(section);

    slots.forEach(function (slot) {
      slot.removeAttribute('data-mobile-hidden');
    });

    section.querySelectorAll('[data-fb-compare-row-value]').forEach(function (cell) {
      cell.removeAttribute('data-mobile-hidden');
    });

    if (window.innerWidth >= mobileBreakpoint) {
      updateSelectedState(section);
      return;
    }

    for (var i = 2; i < slots.length; i += 1) {
      var hiddenIndex = String(i + 1);
      var slot = section.querySelector('[data-fb-compare-slot][data-slot-index="' + hiddenIndex + '"]');
      if (slot) {
        slot.setAttribute('data-mobile-hidden', 'true');
      }
      section.querySelectorAll('[data-fb-compare-row-value][data-slot-index="' + hiddenIndex + '"]').forEach(function (cell) {
        cell.setAttribute('data-mobile-hidden', 'true');
      });
    }

    updateSelectedState(section);
  }

  function bindSection(section) {
    delete section._fbCatalogData;

    if (section.dataset.fbCompareBound !== 'true') {
      section.dataset.fbCompareBound = 'true';

      section.addEventListener('click', function (event) {
        var removeBtn = event.target.closest('[data-fb-compare-remove]');
        if (removeBtn) {
          var removeSlot = removeBtn.closest('[data-fb-compare-slot]');
          if (removeSlot) {
            setSlotEmpty(removeSlot, section);
            updateSelectedState(section);
          }
          return;
        }

        var picker = event.target.closest('[data-fb-compare-picker]');
        if (picker) {
          var pickerSlot = picker.closest('[data-fb-compare-slot]');
          if (pickerSlot) {
            openDialog(section, pickerSlot.dataset.slotIndex);
          }
        }
      });

      var dialog = getDialog(section);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          var closeBtn = event.target.closest('[data-fb-compare-dialog-close]');
          if (closeBtn) {
            event.preventDefault();
            closeDialog(section);
            return;
          }

          var catalogItem = event.target.closest('[data-fb-compare-catalog-item]');
          if (catalogItem) {
            event.preventDefault();
            if (!catalogItem.classList.contains('is-selected')) {
              fillSlotFromCatalog(catalogItem, section);
            }
            return;
          }

          if (event.target === dialog) {
            closeDialog(section);
          }
        });
      }

      if (!section.dataset.fbCompareResizeBound) {
        section.dataset.fbCompareResizeBound = 'true';
        window.addEventListener('resize', function () {
          document.querySelectorAll('[data-fb-compare]').forEach(applyMobileRules);
        });
      }
    }

    applyMobileRules(section);
    hydrateRowValues(section);
    updateSelectedState(section);
    initStickyHeader(section);
  }

  function init() {
    document.querySelectorAll('[data-fb-compare]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fb-compare]');
    if (section) {
      bindSection(section);
    }
  });
})();
